module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"attachments-modal\" title=\"Attachments - ")
    ; __append(escapeFn( maxSizeLegend ))
    ; __append("\" style=\"display: none; font-size: 12px;\">\r\n    <div style=\"padding-bottom: 15px; padding-left: 25px; padding-top: 20px;\">\r\n        <div class=\"col-md-6 nopadding\">\r\n            <input type=\"checkbox\" name=\"insertAttachment\" id=\"insertAttachment\" ")
    ; __append(escapeFn(insertCheck? 'checked': '' ))
    ; __append("/>\r\n            Insert\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n            <input type=\"button\" id=\"insertAttachmentButton\" class=\"hvr-glow\" disabled value=\"...\" />\r\n        </div>\r\n    </div>\r\n    <br>\r\n    <div style=\"padding-bottom: 15px; padding-left: 25px;\">\r\n        <div class=\"col-md-6 nopadding\">\r\n            <input type=\"checkbox\" name=\"printAttachment\" id=\"printAttachment\" ")
    ; __append(escapeFn(printCheck? 'checked': '' ))
    ; __append("/>\r\n            Print\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n            <input type=\"button\" id=\"printAttachmentButton\" class=\"hvr-glow\" disabled value=\"...\" />\r\n        </div>\r\n    </div>\r\n    <br>\r\n    <div style=\"padding-bottom: 15px; padding-left: 25px;\">\r\n        <div class=\"col-md-6 nopadding\">\r\n            <input type=\"checkbox\" name=\"existingInstanceAttachment\" id=\"existingInstanceAttachment\" ")
    ; __append(escapeFn(instanceCheck? 'checked': '' ))
    ; __append("/>\r\n            Existing instance\r\n        </div>\r\n        <div class=\"col-md-2 \">\r\n            <input type=\"button\" id=\"existingInstanceAttachmentButton\" class=\"hvr-glow\" disabled value=\"...\" />\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n")
  }
  return __output;

}